import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const {
		resetSelectedControls,
		searchString,
		IDSelectedCustomer,
		IDSelectedRestaurant,
		IDSelectedCategory,
		IDSelectedSubCategory,
		priceFrom,
		priceTo,
		isUnassignedDishes,
		isDisabledDish,
		isShowOnlyComboItems,
	} = useContext<IDishesContext>(DishesContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]:
			searchString ||
			IDSelectedCustomer ||
			IDSelectedRestaurant ||
			IDSelectedCategory ||
			IDSelectedSubCategory ||
			priceFrom ||
			priceTo ||
			isUnassignedDishes ||
			isDisabledDish ||
			isShowOnlyComboItems,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
